<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="id" label="Ativo" centered>
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon
          v-if="!props.row.active"
          size="is-small"
          icon="cancel"
          type="is-danger"
        ></b-icon>
      </b-table-column>
      <b-table-column field="name" label="Título" width="30%">{{
        props.row.title
      }}</b-table-column>
      <b-table-column field="version" label="Versão" centered>{{
        props.row.version
      }}</b-table-column>
      <b-table-column field="updated_at" label="Atualizado em" centered>{{
        props.row.updated_at | date
      }}</b-table-column>
      <b-table-column field="created_at" label="Criado em" centered>{{
        props.row.created_at | date
      }}</b-table-column>
      <b-table-column label="Opções" centered>
        <button
          @click="edit(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </button>
        <button
          @click="onClickDeleteTerm(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Excluir'"
          color="danger"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>
<script>
import TermOfAcceptanceService from '@/services/term-of-acceptance.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'terms-of-acceptance-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      TermOfAcceptanceService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastfy('Erro ao carregar termos.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteTerm(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Termo',
        message:
          'Tem certeza que deseja <b>excluir</b> este termo? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir termo',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteTerm(id),
      });
    },
    deleteTerm(id) {
      this.loading = true;
      TermOfAcceptanceService.delete(id)
        .then(() => {
          this.toastify('Termo excluído com sucesso.');
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir termo.',
            'error'
          );
        })
        .finally(() => {
          this.loading = false;
          this.load();
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
